export default "__VITE_ASSET__9w0XUxcH__"